import { createFileRoute, redirect } from "@tanstack/react-router";
import { OrgProjectRouteError } from "@/lib/org-project-context/constants";
import { OrgProjectErrorFallback } from "@/lib/org-project-context/error-fallbacks";
import { resolveDashboardOrgProjectRoute } from "@/lib/org-project-context/hooks";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/"
)({
  beforeLoad: async ({ context, params }) => {
    const result = await resolveDashboardOrgProjectRoute(
      context.queryClient,
      params
    );

    if (result.outcome === "valid" || result.outcome === "redirect") {
      throw redirect({
        to: "/orgs/$organizationId/projects/$projectId/home",
        params: {
          organizationId: result.organizationId,
          projectId: result.projectId,
        },
      });
    }

    throw new OrgProjectRouteError(result);
  },
  errorComponent: OrgProjectErrorFallback,
});
